import React, { useEffect } from "react";
import { setPageMeta } from "../seo/setPageMeta";

export default function NewHere() {
  useEffect(() => {
    setPageMeta({
      title: "New Here? | Celebrate Recovery Independence KY",
      description:
        "Visiting Celebrate Recovery for the first time? Learn what to expect on Thursday nights, how meetings work, and how we create a safe and confidential place for healing.",
      canonical: "https://www.crindependenceky.com/new-here",
    });
  }, []);

  return (
    <section>
      <h2 className="page-title">New Here?</h2>
      <p className="page-intro">
        We understand it can be difficult to visit a recovery group for the
        first time. Our hope is to make that first step feel a little easier
        and help you know what to expect before you arrive.
      </p>

      <div className="grid-2">
        <div className="card">
          <h3>What Happens on a Thursday Night?</h3>
          <ul className="list">
            <li>Welcome and fellowship</li>
            <li>Large group worship</li>
            <li>Teaching or testimony</li>
            <li>Gender-Separate open share groups</li>
          </ul>
        </div>

        <div className="card">
          <h3>What Should I Wear?</h3>
          <p>Come as you are. Most people dress casually and comfortably.</p>
        </div>

        <div className="card">
          <h3>Is It Confidential?</h3>
          <p>
            Yes. Celebrate Recovery values confidentiality, respect, and a safe
            place to heal and share honestly.
          </p>
        </div>

        <div className="card">
          <h3>Who Is This For?</h3>
          <p>
            This ministry is for anyone struggling with hurts, habits, or
            hang-ups of any kind. You do not have to face things alone.
          </p>
        </div>

        <div className="card">
          <h3>Do I Need to Register?</h3>
          <p>
            Registration and small group information are handled through
            Community Family Church. If you would like to register, use the
            button below.
          </p>

          <div className="button-row">
            <a
              href="https://www.cfcky.com/support-small-groups/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Register at Community Family Church
            </a>
          </div>
        </div>

        <div className="card">
          <h3>Still Unsure?</h3>
          <p>
            That is completely okay. Many people arrive nervous the first time.
            You are welcome to come, ask questions, and simply take one step at
            a time.
          </p>
        </div>
      </div>
    </section>
  );
}
